import React from "react";
import { connect } from "react-redux";
import ErrorAlert from "../components/ErrorAlert";

class UnsupportedBrowser extends React.Component {
  render() {
    return (
      <div className={""}>
        <ErrorAlert text={this.props.text} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  let text = state.config.text("error.unsupportedbrowser");

  if (state.config.browser.name === "edge") {
    text = state.config.text("error.browseroutofdate");
  }

  return {
    text,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(UnsupportedBrowser);






// WEBPACK FOOTER //
// ./src/containers/UnsupportedBrowser.js